import {gql} from '@apollo/client'

export const OAUTH_CODE_REQUEST = gql`
  mutation OAuthorize($input: OAuthInput!) {
    oauthAuthorize(input: $input) {
      uri
    }
  }
`

export const OAUTH_TOKEN_REQUEST = gql`
  mutation OAuthCodeGrant($input: OAuthCodeGrantInput!) {
    oauthCodeGrant(input: $input) {
      authToken
    }
  }
`

export const SIGN_IN = gql`
  mutation signIn($input: AuthInput!) {
    signIn(input: $input) {
      authToken
      refreshToken
      status
    }
  }
`

export const REFRESH_TOKEN = gql`
  mutation refreshToken($input: AuthInput!) {
    refreshToken(input: $input) {
      authToken
      refreshToken
    }
  }
`

export const SIGN_OUT = gql`
  mutation signOut($input: SignOutInput!) {
    signOut(input: $input) {
      revoked
    }
  }
`
